import React from 'react';
import SectionHeading from '../../Components/Shared/SectionHeading';
import oil from '../../Assert/oil.png'

const Popular = () => {
    return (
        <div className='my-16 hidden md:block'>
            <div className="my-10">
                <SectionHeading text={"Popular"} />
            </div>
            <div className="grid lg:grid-cols-4 sm:grid-cols-2 grid-cols-1  gap-x-8 gap-y-4">
                {
                    Array.from({ length: 4 }).map((_, id) => {
                        return (
                            <div key={id}>
                                <img src={oil} alt="" />
                            </div>
                        )
                    })
                }
            </div>
        </div>
    );
};

export default Popular;